import React, { useEffect, useState} from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { Container, Typography, Button, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material'
import { setInvoiceNumber, 
        setDescription, 
        setPaymentReviewTitle} from './utilities/paymentUtilities';
import api from './utilities/apiInterceptor';
import axios from 'axios';

const PaymentReview = () => {
    const { type, encodedUrl } = useParams();
    const [order, setOrder] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [formData, setFormData] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        let response;
        const fetchOrder = async () => {
            try {
                response = await axios.get(`https://payments.leviton.com/api/get-payment/${type}/${encodedUrl}`);
                setOrder(response.data[0])
        
                
            } catch (error) {
                console.error('Error fetching payment information', error);
        }
        
    };
    fetchOrder();
    
}, [type, encodedUrl, navigate]);


    const handleProceedClick = async() => {
        try {
            let response = await api.get(`/get-authorize-net-data/${encodedUrl}`);
            response = response.data
            setFormData({
                x_type: response.x_type,
                x_version:  response.x_version,
                x_login: response.x_login,
                x_show_form:response.x_show_form,
                x_method: response.x_method,
                x_amount: response.x_amount,
                x_description: response.x_description,
                x_cust_id: response.x_cust_id,
                x_invoice_num: response.x_invoice_num,
                order_number: response.order_number,
                x_po_num: response.x_po_num,
                x_fp_sequence: response.x_fp_sequence,
                x_fp_timestamp: response.x_fp_timestamp,
                x_fp_hash: response.x_fp_hash,
                x_header_html_payment_form: response.x_header_html_payment_form,
                x_relay_always: response.x_relay_always,
                x_relay_url: response.x_relay_url,
                ref_uuid: response.ref_uuid,
                ref_code: response.ref_code,
                show_debug: response.show_debug
            });

            setModalOpen(true);
        } catch(error) {
            console.error('Authorize.net API call failed', error)
        }};

        const handleConfirm = () => {
            document.getElementById('paymentForm').submit()
        };

        const handleCloseModal = () => {
            setModalOpen(false);
        };

    if(!order) {
        return <Typography>Loading...</Typography>;
    }

return (
    <Container>
        <Typography variant='h4' gutterBottom sx={{ marginTop: '55px' }}>{setPaymentReviewTitle(order.payment_type)}</Typography>
        <Typography variant='body1' gutterBottom>
            Please review the information and click Submit
        </Typography>
        <Box>
            <Typography><strong>Customer Number:</strong> {order.x_cust_id}</Typography>
            <Typography><strong>Invoice Number:</strong> {setInvoiceNumber(order.type, order.x_invoice_num)}</Typography>
            <Typography><strong>Amount:</strong> {order.x_amount}</Typography>            
            <Typography><strong>Order Number:</strong> {order.x_order_num}</Typography>
            <Typography><strong>Description / Comments: </strong> {setDescription(order.type,order.description)}</Typography>
            <Typography><strong>Purchase Order Number:</strong> {order.x_po_num}</Typography>
        </Box>
        <Button
            variant="contained"
            style={{backgroundColor: '#76b900'}}
            onClick={handleProceedClick}
            sx={{mt: 2}}
            >
            Proceed to Authorize.Net Secure Payment Form
        </Button>

        <form id='paymentForm'
            action="https://secure2.authorize.net/gateway/transact.dll"
            method="POST"
            style={{ display: 'none'}}>
            <input type='hidden' name='x_type' value={formData.x_type} />
            <input type='hidden' name='x_version' value={formData.x_version} />
            <input type='hidden' name='x_login' value={formData.x_login} />
            <input type='hidden' name='x_show_form' value={formData.x_show_form} />
            <input type='hidden' name='x_method' value={formData.x_method} />
            <input type='hidden' name='x_amount' value={formData.x_amount} />
            <input type='hidden' name='x_description' value={formData.x_description} />
            <input type='hidden' name='x_cust_id' value={formData.x_cust_id} />
            <input type='hidden' name='x_invoice_num' value={formData.x_invoice_num} />
            <input type='hidden' name='order_number' value={formData.order_number} />
            <input type='hidden' name='x_po_num' value={formData.x_po_num} />
            <input type='hidden' name='x_fp_sequence' value={formData.x_fp_sequence} />
            <input type='hidden' name='x_fp_timestamp' value={formData.x_fp_timestamp} />
            <input type='hidden' name='x_fp_hash' value={formData.x_fp_hash} />
            <input type='hidden' name='x_header_html_payment_form' value={formData.x_header_html_payment_form} />
            <input type='hidden' name='x_relay_always' value={formData.x_relay_always} />
            <input type='hidden' name='x_relay_url' value={formData.x_relay_url} />
            <input type='hidden' name='ref_uuid' value={formData.ref_uuid} />
            <input type='hidden' name='ref_code' value={formData.ref_code} />
            <input type='hidden' name='show_debug' value={formData.show_debug} />
        </form>

        <Dialog
            open= {modalOpen}
            onClose= {handleCloseModal}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
            >
                <DialogTitle id='alert-dialog-title'>
                    {'You\'re leaving payments.leviton.com'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                    You're heading to a secure website managed by authorize.net. You will now be redirected. Would you like to continue?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                     onClick={handleConfirm} 
                     style={{backgroundColor: '#76b900', color: 'white'}}
                     >
                        Yes
                    </Button>
                    <Button onClick={handleCloseModal} style={{ color: '#76b900'}}>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
    </Container>
)
};

export default PaymentReview;
